import {
  constFunction,
  constString,
  escapeDots,
  list,
  opConcat,
  opDropNa,
  opMap,
  opPick,
  opRunHistory,
  opRunSummary,
  typedDict,
  varNode,
} from '@wandb/weave-ui/cg';

export interface WeaveConfig {
  panel2Config?: any;
  defaultWorkspaceState?: {
    panel2Config?: any;
    key: string;
    keyType: string;
  };
}

export function weavePanelForWeaveKey(
  key: string,
  keyType: string
): WeaveConfig {
  // var name does not matter, PanelExpression will auto-replace.
  // Using something unique & ugly to force out errors.
  const panel2Config: any = {};
  const vNode = varNode(list('run'), 'runs');

  if (keyType === 'wb_trace_tree') {
    const mappedNode = opMap({
      arr: vNode,
      mapFn: constFunction({row: typedDict({})}, ({row}) => {
        return opPick({
          obj: opRunHistory({
            run: row,
          }),
          key: constString(key),
        });
      }),
    });
    const concatNode = opDropNa({
      arr: opConcat({arr: opDropNa({arr: mappedNode})}),
    });
    panel2Config.exp = concatNode;
    // panel2Config.exprAndPanelLocked = true;
    panel2Config.panelId = 'wb_trace_tree-traceDebugger';
  } else {
    const tableNode = opPick({
      obj: opRunSummary({run: vNode}),
      key: constString(escapeDots(key)),
    });
    panel2Config.exp = tableNode;
  }

  return {
    panel2Config,
    defaultWorkspaceState: {
      panel2Config,
      key,
      keyType,
    },
  };
  // Uncomment the below to auto-inject the table merge. For now, I
  // prefer not auto-injecting, but this may change as we get feedback.
  // const newExp = callOp(Panel2.panelIdToPanelOpName('merge'), {
  //   input: runTableNode,
  //   config: Op.constNodeUnsafe('any', {}),
  // });

  // return {
  //   panel2Config: {exp: newExp},
  // };
}
